import React from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import { Theme } from '../../config/theme';

import ContentContainer from '../ContentContainer';

let styles;

const HomepageInspiration = props => (
  <div className={css(styles.inspirational, styles[`inspirational_${props.position}`])}>
    <ContentContainer
      styles={styles.inspirational_content}
      reverse={Boolean((props.position % 2) && !Theme.isMobile)}
    >
      <div className={css(styles.inspirational_half)}>
        <div className={css(styles.description)}>{props.description}</div>
        <div className={css(styles.title)}>{props.title}</div>
        <div className={css(styles.text)}>{props.text}</div>
      </div>
    </ContentContainer>
  </div>
);

export default HomepageInspiration;

HomepageInspiration.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  position: PropTypes.number.isRequired,
};

styles = StyleSheet.create({
  inspirational: {
    display: 'flex',
    position: 'relative',
    width: '100vw',
    height: 700,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundPosition: 'center',
    backgroundSize: 'cover',

    [Theme.mobile_query]: {
      height: 'auto',
      paddingTop: 130,
      paddingBottom: 40,
      backgroundPosition: 'top center',
    },
  },
  inspirational_1: {
    backgroundImage: 'url("/images/inspirational_1.png")',

    [Theme.mobile_query]: {
      backgroundImage: 'url("/images/inspirational_mob_1.png")',
    },
  },
  inspirational_2: {
    backgroundImage: 'url("/images/inspirational_2.png")',

    [Theme.mobile_query]: {
      backgroundImage: 'url("/images/inspirational_mob_2.png")',
    },
  },
  inspirational_3: {
    backgroundImage: 'url("/images/inspirational_3.png")',

    [Theme.mobile_query]: {
      backgroundImage: 'url("/images/inspirational_mob_3.png")',
    },
  },
  inspirational_content: {
    display: 'flex',
    alignItems: 'center',
  },
  inspirational_half: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',

    [Theme.mobile_query]: {
      width: '100%',
    },
  },

  description: {
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    fontSize: 16,
    letterSpacing: 4,
    textTransform: 'uppercase',
    color: Theme.white,
    marginBottom: 20,

    [Theme.mobile_query]: {
      fontSize: 15,
      letterSpacing: 2,
    },
  },
  title: {
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
    fontSize: 100,
    width: 500,
    color: Theme.primary,
    marginBottom: 40,

    [Theme.mobile_query]: {
      fontSize: 45,
      width: 230,
      marginBottom: 20,
    },
  },
  text: {
    fontFamily: Theme.font_family_primary,
    fontWeight: Theme.font_weight_primary,
    fontSize: 18,
    lineHeight: '24px',
    color: Theme.white,
    width: 310,

    [Theme.mobile_query]: {
      width: '100%',
      fontSize: 15,
      fontWeight: 500,
      lineHeight: 1.4,
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/HomepageInspiration/index.js